import styled from 'styled-components';
import {RowStyles, ColumnStyles} from './../../../../../../stories/core-components/Layouts/Layouts';

export const listItem = styled.label`
  ${RowStyles}
  padding: 0.5rem 1rem;
  align-items: flex-start;
  &:active,
  &:focus,
  &.active {
    background: #eff3f8;
  }
`;
export const listContent = styled.div(
  props => `
    ${ColumnStyles}
    flex: 7;
    padding-bottom:0.5rem;
    width: 80%;
    .time {
        font-family:${props.theme.font.fontFamily};
        font-size: 1.5rem;
        color: #1c1c1c
    }
    .location {
        font-family:${props.theme.font.fontFamily};
        font-size: 1rem;
        color: #1c1c1c;
        font-weight: bold;
        padding: 0.3rem 0;
    }
    .address {
        color: #777;
        font-size: 1.1rem
    }
`,
);
